import { Drawer, FlexContainer } from '@act/storybook';
import { SmartContentDisplay } from '@act/storybook/display/SmartContentDisplay/SmartContentDisplay';
import { Box, Button, Divider, Typography } from '@mui/material';
import HtmlDisplayer from 'react-components/components/HtmlDisplayer';
import { membersAppSelectors } from 'redux/slices/memberSlice.slice';
import { metaSliceSelectors } from 'redux/slices/metaSlice.hook';
import { needsSelectors } from 'redux/slices/needs.slice';
import { InfoContainer, LabeledDatum } from '@act/toolkit/styles/DataDisplay';
import NeedHistory from '../components/history/NeedHistory';
import NeedTimeAlert from './components/NeedTimeAlert';

export interface NeedDetailSideDrawerProps {
  open: boolean;
  onClose: () => void;
  needId: number;
}

export default function NeedDetailSideDrawer({
  open,
  onClose,
  needId,
}: NeedDetailSideDrawerProps) {
  const needMetadata = metaSliceSelectors.useSelectNeedsMetadata();
  const need = needsSelectors.useSelectNeedById(needId);
  const member = membersAppSelectors.useSelectMemberById(need?.memberId);
  const issue = needMetadata.data.issues.find(i => i.id === need.issueId);
  const category = needMetadata.data.categories.find(
    c => c.id === issue?.categoryId
  );
  const domain = needMetadata.data.domains.find(
    d => d.id === category?.domainId
  );

  return (
    <Drawer open={open} onClose={onClose} title={`Need for ${member?.name}`}>
      <FlexContainer direction="column" height="100%" minHeight="0">
        <Box style={{ flex: 1, overflow: 'auto', padding: '0 12px' }}>
          <Box padding="8px 0">
            <InfoContainer>
              <LabeledDatum label={'Domain'} datum={domain?.label} />
              <LabeledDatum label={'Category'} datum={category?.label} />
              <LabeledDatum label={'Issue'} datum={issue?.label} />
              <LabeledDatum
                label={'Reason'}
                datum={
                  <SmartContentDisplay maxHeight={150}>
                    <HtmlDisplayer innerHtml={need?.reason} />
                  </SmartContentDisplay>
                }
              />
            </InfoContainer>
          </Box>
          <Box padding="16px 0">
            <NeedTimeAlert need={need} />
          </Box>
          <Divider style={{ margin: '24px -12px 8px' }} />
          <FlexContainer
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            height="fit-content"
            overflowAllVisible
          >
            <Typography variant="titleMedium">History</Typography>
          </FlexContainer>
          <NeedHistory need={need} editMode={false} detailMode={true} />
        </Box>
        <FlexContainer
          direction="row"
          padding="16px 24px"
          margin="auto 0 0"
          justifyContent="flex-end"
          height="fit-content"
        >
          <Button
            onClick={onClose}
            variant="contained"
            style={{ padding: '8px 24px' }}
          >
            Close
          </Button>
        </FlexContainer>
      </FlexContainer>
    </Drawer>
  );
}
